export default [
    {value: 1, label: 'Crédito Nuevo'},
    {value: 2, label: 'Actualización'},
    {value: 3, label: 'Unificación'},
]